<div class="grid reset-password-container full-height-grid mt-0">
  <div class="col-12 md:col-5 fixed-sidebar p-0">
    <app-login-info />
  </div>
  <div class="col-12 md:col-7 scrollable-content pt-6">
    <div class="grid">
      <div class="col-1"></div>
      <div class="col-10">
        <form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()">
          <div class="grid">
            <div class="flex col-12 reset-password-title gap-2 mb-4">
              {{ 'Auth.ResetPassword' | translate }}
            </div>
            <div class="col-12 mb-4 justify-content-center align-items-center">
              {{ 'Auth.ResetPasswordInstruction' | translate }}
            </div>
            <div class="col-12 mb-4">
              <div class="flex flex-column">
                <label class="input-title" htmlFor="password">{{ 'Auth.NewPassword' | translate }}</label>
                <app-custom-password class="custom-component"
                  formControlName="password"
                  placeHolder="{{ 'Auth.NewPassword' | translate }}" />
                @if (
                  resetPasswordForm.controls.password.touched &&
                  resetPasswordForm.controls.password.hasError('required')
                ) {
                  <p-message styleClass="justify-content-start align-items-center p-inline-message-validation mt-2"
                    icon="pi pi-info-circle"
                    text="{{ 'SignUp.PasswordRequired' | translate }}" />
                }

                @if (
                  resetPasswordForm.controls.password.touched && resetPasswordForm.controls.password.hasError('pattern')
                ) {
                  <p-message styleClass="justify-content-start align-items-center p-inline-message-validation mt-2"
                    icon="pi pi-info-circle"
                    text="{{ 'Auth.UnmetCriteria' | translate }}" />
                }
              </div>
            </div>
            <div class="col-12 mb-4">
              <div class="flex flex-column">
                <label class="input-title" htmlFor="confirmpassword">{{ 'Auth.ConfirmNewPassword' | translate }}</label>
                <p-password
                  [feedback]="false"
                  [toggleMask]="true"
                  id="confirmPassword"
                  [attr.aria-describedby]="'Auth.ConfirmNewPassword' | translate"
                  formControlName="confirmPassword"
                  class="w-full" />

                @if (
                  resetPasswordForm.controls.confirmPassword.touched &&
                  resetPasswordForm.controls.confirmPassword.hasError('required')
                ) {
                  <p-message styleClass="justify-content-start align-items-center p-inline-message-validation mt-2"
                    icon="pi pi-info-circle"
                    text="{{ 'SignUp.PasswordRequired' | translate }}" />
                }

                @if (
                  resetPasswordForm.controls.confirmPassword.touched &&
                  resetPasswordForm.controls.confirmPassword.hasError('passwordMismatch')
                ) {
                  <p-message styleClass="justify-content-start align-items-center p-inline-message-validation mt-2"
                    icon="pi pi-info-circle"
                    text="{{ 'Auth.UnmatchedCredentials' | translate }}" />
                }
              </div>
            </div>
            <div class="col-12 mb-4">
              <p-button [label]="'Auth.ChangePassword' | translate"
                type="submit"
                [disabled]="!resetPasswordForm.valid"
                [loading]="resetInProgress"
                styleClass="p-button-rounded w-full" />
            </div>
          </div>
        </form>
      </div>
      <div class="col-1"></div>
      <div class="col-12">
        <div class="col-2 p-0 col-offset-5">
          <app-language-selector />
        </div>
      </div>
    </div>
  </div>
</div>
